import type { LoaderOptions } from '@/loaders/LoaderOptions';

import { getServiceProtocolsQueryOptions, unitByIdQueryOptions } from '@/service/vpc/queryOptions';
import { chassis } from '@/utils';

export const loaderUnitMaintenancePage = async (opts: LoaderOptions) => {
  const { endCustomerUnitId } = opts.params;

  if (!endCustomerUnitId) {
    return;
  }

  // First fetch the unit data to get serial numbers and chassis IDs
  const unit = await opts.context.queryClient.ensureQueryData(unitByIdQueryOptions({ endCustomerUnitId }));

  // Extract serial numbers and chassis IDs from the unit data
  const chassisIdentifiers = chassis.getUnitsChassisIdentifier(unit) || [];

  const serviceProtocols = await opts.context.queryClient.ensureQueryData(
    getServiceProtocolsQueryOptions({ chassisIdentifiers })
  );

  return { unit, serviceProtocols };
};
